import { render, staticRenderFns } from "./StartRegistration.vue?vue&type=template&id=038d741d&scoped=true&"
import script from "./StartRegistration.vue?vue&type=script&lang=js&"
export * from "./StartRegistration.vue?vue&type=script&lang=js&"
import style0 from "./StartRegistration.vue?vue&type=style&index=0&id=038d741d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038d741d",
  null
  
)

export default component.exports